export default __webpack_public_path__ + "static/media/clinic-image-03.fa26ab8d.png";